import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemDataLimitProps<
  TRow extends object = Record<string, unknown>,
> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
}

export const MenuItemDataLimit = <
  TRow extends object = Record<string, unknown>,
>(
  props: MenuItemDataLimitProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  //#endregion useMemo

  //#region useState

  //#endregion useState

  // const handleRedirect = () => {
  //   // Example redirect
  //   // window.location.href = `/details/${row.id}`;
  // };

  // const handleOpenModal = () => {
  //   // Trigger modal logic here
  //   // console.log("Open modal for", row);
  //   handleClose();
  // };

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      <MenuItem onClick={handleEditAction}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Edit")} />
      </MenuItem>
      <MenuItem onClick={handleDeleteAction}>
        <ListItemIcon>
          <DeleteIcon color="error" fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Delete")} />
      </MenuItem>

      {/*<MenuItem onClick={handleRedirect}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <OpenInNewIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Go to Details" />*/}
      {/*</MenuItem>*/}
      {/*<MenuItem onClick={handleOpenModal}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <EditIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Open Modal" />*/}
      {/*</MenuItem>*/}
      {/*<MenuItem onClick={handleRemoveAction}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <DeleteIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Remove" />*/}
      {/*</MenuItem>*/}
    </>
  );
};
